module.exports = __webpack_public_path__ + "media/images/lp/sv/img/pc/contents-bg-6ee16bb47b24a90badf5cf2674b8a5db.png";